import { render, staticRenderFns } from "./FormGeneratorItems.vue?vue&type=template&id=4b6b1b7e&"
import script from "./FormGeneratorItems.vue?vue&type=script&lang=js&"
export * from "./FormGeneratorItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports